import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { TERM_PRODUCT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetTermProductRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = TERM_PRODUCT_URL;

  constructor(applicationId, doximProductId) {
    super();
    const paramList = [applicationId, doximProductId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
